import { render } from "./RiProdcategory07.vue?vue&type=template&id=07cf1d29"
import script from "./RiProdcategory07.vue?vue&type=script&lang=js"
export * from "./RiProdcategory07.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdcategory07.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07cf1d29"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07cf1d29', __exports__)) {
    api.reload('07cf1d29', __exports__)
  }
  
  module.hot.accept("./RiProdcategory07.vue?vue&type=template&id=07cf1d29", () => {
    api.rerender('07cf1d29', render)
  })

}


export default __exports__